window.SP = window.SP || {};
SP.promptConfig = SP.promptConfig || {};


SP.promptConfig = Object.assign( {
    endpoint: "https://orders.rosefarmers.com/api/newsletter-signup",
    id: "promptEmail",
    site: "Rose Farmers",
    logo: "https://cdn.shopify.com/s/files/1/0338/1732/9799/files/rose-farmers-logo_1_360x.png?v=1584374538",
    prompt1: "Save 35%<span>*</span>",
    prompt2: "Claim Your Coupon Now!",
    style: {btnBg: "#E20074"},
    campaign: "rf-web-coupon-modal",
    launchSec: 8,
    promptedCookie: "prompted"
}, SP.promptConfig);

SP.prompt = {};

SP.prompt.display = function () {


    var display = function(){
        if( SP.stopPrompt ) {
            // do nothing, prompt was stopped
        } else {
            SP.prompt.injectStyle();
            SP.prompt.triggerPrompt();
        }
    };


    if (SP.promptConfig.launchSec) {
        setTimeout(display, SP.promptConfig.launchSec * 1000);
    } else {
        display();
    }

};


SP.prompt.injectStyle = function(){
    // create/inject styles
    var style = document.createElement('style');
    style.innerHTML =
        '.prompt-modal-outer{ position: fixed; left: 0; top: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.4); z-index: 500}' +
        '.prompt-modal{ background-color: #fff; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);}' +
        '.prompt-close{ cursor: pointer; }' +
        '.prompt-logo{ max-width: 240px; width: 240px; height: auto; display: block; margin: 0 auto; margin-bottom: 15px;}' +
        '.prompt-btn{ background-color: ' + SP.promptConfig.style.btnBg + '; color: #fff; font-weight: bold; min-width: 240px; display: block; margin: 10px auto; height: 40px; line-height: 40px; text-align: center; cursor: pointer;}' +
        'a.prompt-btn:not([disabled]):hover, a.prompt-btn:focus{ color: #fff; }' +
        '.prompt-btn-alt{ background-color: #eee; color: #888; font-weight: normal;}' +
        '.prompt-btn-alt:hover{ background-color: #ddd; color: #555;}' +
        '.prompt-field{ display: block; min-width: 240px; border: 1px solid #333; height: 40px; line-height: 40px; font-size: 18px; color: #111; margin-top: 5px; max-width: 320px; width: 100%;}' +
        '.prompt-field::placeholder{ color: #888 }' +
        'input.prompt-field[name=email]{ padding-left: 40px; background-repeat: no-repeat; background-size: 20px 15px; background-position-x: 10px; background-position-y: center; ' +
        '       background-image: url("data:image/png;base64;,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAMAAADTRh9nAAAAZlBMVEWttb2vt7+ttb2ttb0AAADR1dqxucC3vsW+xcuwuMCxucCzusLIzdP4+fr29/jR1dnz9fa7wcjn6uzN0da2vcTx8vTu8PLc3+O/xcu5v8ayucHU2NzDyM7q7O7d4OPHzNGzusKttb2TNHDgAAAADXRSTlP5E4FGAASARCrgwJMLt4TFeQAAAIFJREFUGNN1jtkSwiAMAINCWy+C3KX1+v+fNODgmM64T7Awm4Cchh1jGCWcDw9kOJhAgLlwrnuSkTs9V+ntrwv5VeVSkv466137aejQbSqJmm1QWHNoOTdT6iPphjUc80pvXRL34vCJrdIlERe0fc9/y980w/gR1Ak2HAVIJTYo+Qaqig09qG+G9wAAAABJRU5ErkJggg=="); }' +
        'div.prompt-close{ position: absolute; right: 0; top: 0; font-weight: light; font-size: 40px; padding: 0 20px}' +
        '.prompt-welcome{ font-size: 14px; text-align: center; }' +
        '.prompt-h2{ width:320px; font-size: 24px; text-align: center; margin: 0; max-width: 320px; font-weight: bold;}' +
        '.prompt-h2 + .prompt-h2 {font-size: 20px; margin-top: 10px;}' +
        '.prompt-h2 span { font-size: 14px; vertical-align: top; display: inline-block; margin-top: 5px;}' +
        '.prompt-h3{ font-size: 18px; text-align: center; max-width: 320px; margin-top: 25px; }' +
        'div.prompt-side-image{ width: 360px; height: 400px; background-position-x: -18px; background-size: cover; background-image: url("https://rf-static-media-1852885183513.s3.amazonaws.com/RedImage5_480x480.jpg"); }' +
        'div.prompt-row{ display: flex; flex-direction: row; justify-content: flex-start;}' +
        'div.prompt-content{ padding: 20px 20px 0 20px }' +
        'p.terms{ font-size: 10px; margin-bottom: 10px; text-align: center}' +
        '@media( max-width: 750px ){ .prompt-side-image{ display: none; } }';
    '@media( max-width: 500px ){ .prompt-modal{ padding: 40px; } }';
    ;

    // Get the first script tag
    var ref = document.querySelector('script');

    // Insert our new styles before the first script tag
    ref.parentNode.insertBefore(style, ref);
};

SP.prompt.triggerPrompt = function() {

    var modalMarkup = document.createElement("div");
    modalMarkup.setAttribute("id", SP.promptConfig.id);
    modalMarkup.setAttribute("class", "prompt-modal-outer");
    modalMarkup.innerHTML =
        '<div class="prompt-modal">' +
        '<div class="prompt-close">&times</div>' +
        '<div class="prompt-row">' +
        '<div class="prompt-side-image"></div>' +
        '<div class="prompt-content">' +
        '<img class="prompt-logo" src="' + SP.promptConfig.logo + '"/>' +
        '<div class="prompt-h2">Welcome<br/>T-Mobile Customers!</div>' +
        '<div class="prompt-h2" style="font-weight: normal">Enjoy your Exclusive Discounted Roses with Free Shipping.</div>' +
        '<div class="prompt-h3">Sign up for updates &amp; future promos!</div>' +
        '<input type="text" name="email" class="prompt-field" placeholder="Email address"/>' +
        '<a href="#" class="prompt-btn prompt-btn-submit">Submit</a>' +
        '<a href="#" class="prompt-btn prompt-btn-alt prompt-close">No Thanks</a>' +
    '</div>' +
    '</div>' +
    '</div>';
    document.getElementsByTagName('body')[0].appendChild( modalMarkup );


    var modal = document.getElementById(SP.promptConfig.id);
    var closers = modal.getElementsByClassName("prompt-close");

    var handleClose = function(e){
        modal.parentNode.removeChild( modal );
        return false;
    };

    for( var i = 0; i < closers.length; i++){
        closers[i].addEventListener('click', handleClose);
    }



    var btnClicked = false;

    var handleSubmit = function(e){
        e.preventDefault();

        if (btnClicked) {
            return;
        }

        var email = modal.querySelector("input[name=email]").value;
        if( email.length == 0 ){
            alert("Please enter an email address to receive updates!");
        } else if( email.indexOf("@") == -1 ){
            alert("\"" + email + "\" is not a valid email address.\n\nPlease check your email and submit again.");
        } else {
            btnClicked = true;
            fetch(SP.promptConfig.endpoint, {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    "action": "submit",
                    "email": email,
                    "url": window.location.href,
                    "campaign": SP.promptConfig.campaign || null,
                    "affiliate": SP.promptConfig.affiliateId || null
                })
            })
                .then( function(resp){return resp.json();} )
                .then( function(data){

                    btnClicked = false;

                    if( data.success == false ){
                        alert( data.error );
                        return;
                    }

                    modal.getElementsByClassName("prompt-h2")[0].innerHTML = "Thank you!";
                    modal.getElementsByClassName("prompt-h3")[0].innerHTML = "";
                    $(modal).find('.prompt-h2').last().html('Enjoy Your Discount & Our Exquisite Roses!');

                    var toHide = modal.querySelectorAll(".prompt-welcome, input[name=email], .prompt-btn-submit");
                    for( var i = 0; i < toHide.length; i++ ){
                        toHide[i].parentNode.removeChild( toHide[i] );
                    }


                    var closeBtn = modal.getElementsByClassName("prompt-btn-alt")[0];
                    closeBtn.innerHTML = "Continue to Site &rarr7;";
                    closeBtn.classList.remove("prompt-btn-alt");
                });
        }


        return false;
    };

    modal.getElementsByClassName("prompt-btn-submit")[0].addEventListener("click", handleSubmit);
    modal.querySelector("input[name=email]").addEventListener("keyup", function(e){
        if( e.key == "Enter" ){
            handleSubmit();
        }
    });
};
